import { dispatchLegacyAnalyticsEvent } from "@/utils/analytics";
import {
  getAnalyticsPageType,
  getAppliedFilterNvals,
  getAppliedFilters,
  SelectedFacetProps,
} from "@/utils/setJLData";
import { FILTER_APPLIED } from "@/utils/events";
import { FacetDetail } from "@/types/productListing";

type Params = {
  pageType: string;
  results?: number;
  getSelectedFacets: () => SelectedFacetProps[];
};

export const createDispatchFacetAnalytics = ({
  pageType,
  results = 0,
  getSelectedFacets,
}: Params) => {
  return (eventType: string, facetName: string, facetDetails: FacetDetail) => {
    const { label, trackingId } = facetDetails;

    const currentSelectedFacets = getSelectedFacets();
    const updatedSelectedFacets =
      eventType === FILTER_APPLIED
        ? currentSelectedFacets.concat({ facetName, ...facetDetails })
        : currentSelectedFacets.filter(
            (f) => !(f.facetName === facetName && f.label === label),
          );

    dispatchLegacyAnalyticsEvent(eventType, {
      pagetype: getAnalyticsPageType(pageType, results),
      // All applied filters *after* the filter has been added/removed i.e. the result
      filterCombination: facetName
        ? getAppliedFilters(updatedSelectedFacets)
        : "",
      filterCombinationNvals: facetName
        ? getAppliedFilterNvals(updatedSelectedFacets)
        : "",
      // Specific filter being added/removed
      appliedFilter: facetName
        ? `${facetName}:${label}`.toLowerCase()
        : getAppliedFilters(currentSelectedFacets),
      appliedFilterNval: facetName
        ? `${trackingId}`
        : getAppliedFilterNvals(currentSelectedFacets),
    });
  };
};
